import { GameModelEvent } from "@nolimitcity/slot-game/bin/model/GameModel";

import { EventsManager, ReelsEvents } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { ColorSet, log } from "../../../abstracts/utils/AbstractConsole";
import { Apocalypse } from "../../Apocalypse";
import { ApocalypseReelsView } from "./ApocalypseReelsView";

export class ApocalypseReelsController extends AbstractModuleController {
    constructor() {
        super();
    }

    public get name(): string {
        return `ApocalypseReelsController`;
    }

    public get view(): ApocalypseReelsView {
        if (this._view === undefined || this._view === null) {
            this._view = new ApocalypseReelsView();
        }
        return this._view as ApocalypseReelsView;
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.trigger(ReelsEvents.GET_REELS_VIEW, this.view);

        EventsManager.trigger(ReelsEvents.GET_NORMAL_REELS, this.view.getNormalReels());

        EventsManager.trigger(ReelsEvents.GET_FREESPIN_REELS, this.view.getFreespinReels());

        Apocalypse.model.events?.on(GameModelEvent.GAME, () => {
            this.generateNextReels();
        });
    }

    protected handleView(): void {
        super.handleView();

        let currentReels: string[][] = Object.assign([], Apocalypse.model.currentSymbols);

        this.view.generateInitialReels(currentReels);
    }

    protected generateNextReels(): void {
        log(`setNextReels | currentMode: ${Apocalypse.model.gameData.mode} `, ColorSet.YELLOW);
    }
}
